import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}

/** Coarse pointer = touch device; used to skip autofocus, which would pop the keyboard. */
export const isTouch = typeof window !== "undefined" && window.matchMedia("(pointer: coarse)").matches;
